import { executeRequest, Request } from '@jfs/network'

import { RootStore } from '../data/store'
import { clean, dateFormatter, DateFormatTypes } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'
import { getApprovalDataType, getFileType } from './getAuditTrialList'

const responseParser = (data: any) => {
  return data
}

export const initiateExportFileApi: any = (req, type: any, isElevated: string, abortController: any) => {
  const config = sitConfig(RootStore.session.getTokens, abortController)

  const url = getUrl(APIEndPoints.genericExportFile + '?type=' + type + '&elevated=' + isElevated)
  const request: Request<{}> = {
    config: config,
    apiPath: url,
    method: 'POST',
    responseType: 'arraybuffer',
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export const downloadExportFileApi: any = (fileName: string, isElevated: string, abortController: any) => {
  const config = sitConfig(RootStore.session.getTokens, abortController)
  const url = getUrl(APIEndPoints.genericExportFile + '?fileName=' + fileName)
  const request: Request<{}> = {
    config: config,
    apiPath: url,
    method: 'GET',
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export const getExportFileRequest = (data) => {
  return {
    inputFilter: { ...clean(data), ...(data?.isActive && { isActive: data?.isActive === 'Active' ? true : false }) },
    configParams: {
      page: 1,
      size: 10,
    },
  }
}
export const getExportAuditTrailsRequest = (isAccessConfigPriviledged, username, approvalDataType) => {
  return {
    filter: {
      ...(!isAccessConfigPriviledged && username?.length > 0 && { username: username }),
      ...(approvalDataType?.length > 0 && {
        approvalDataType: getApprovalDataType(approvalDataType),
      }),
      ...getFileType(approvalDataType),
      fromDate: `${dateFormatter(RootStore?.selectedDateInfo?.fromDate, DateFormatTypes.YYYYMMDD)}00:00:00`,
      toDate: `${dateFormatter(RootStore?.selectedDateInfo?.toDate, DateFormatTypes.YYYYMMDD)}23:59:59`,
    },
  }
}
